module.exports = __webpack_public_path__ + "static/problem_illustration-0beea2d447c42b57f099fe45406e2926.png";